import { useAtomValue } from "jotai";
import type { FunctionComponent } from "react";

import { hamburgerMenuAtom } from "./atoms";
import { DynamicHamburgerMenuDefault, DynamicHamburgerMenuMagazinesStyle } from "./dynamics";

export const HamburgerMenu: FunctionComponent = () => {
  const { variant } = useAtomValue(hamburgerMenuAtom);
  switch (variant) {
    case "magazines-style":
      return <DynamicHamburgerMenuMagazinesStyle />;
    default:
      return <DynamicHamburgerMenuDefault />;
  }
};

HamburgerMenu.displayName = "HamburgerMenu";
